import { Comment } from 'vue'

export function isVNodeEmpty (vnode) {
  return !vnode || asArray(vnode).every(
    (vnode) => vnode.type === Comment || vnode.children?.length === 0
  )
}

export function asArray (arg) {
  return Array.isArray(arg) ? arg : arg != null ? [arg] : []
}

export function testSlot (slot) {
  if (!slot || !slot()) return false
  return slot().some((vnode) => !isVNodeEmpty(vnode))
}